module.exports = __webpack_public_path__ + "static/media/025_concepts_nk_2-04.6aa21d91.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/kp/025_concepts_nk_2-04.png
// module id = 523
// module chunks = 0